import { useQuery } from "@tanstack/react-query";
import { useAuthUser } from "@/hooks/useAuthUser";
import { queryKeys } from "@/lib/queryKeys";
import { isSuperAdmin } from "@/services/adminService";

export function useSuperAdmin() {
  const { user, isLoading: isAuthLoading } = useAuthUser();

  const { data, isLoading: isQueryLoading } = useQuery({
    queryKey: queryKeys.admin.superAdmin,
    queryFn: isSuperAdmin,
    enabled: !!user,
    staleTime: 10 * 60 * 1000,
  });

  return {
    isSuperAdmin: data ?? false,
    isLoading: isAuthLoading || (!user ? false : isQueryLoading),
  };
}
